import * as React from 'react'
import { Typography } from 'cs-kevlar-react'

export type UserDisplayViewModel = {
    name: string
    fullName: string
    isActive: boolean
}
interface UserDisplayNameProps {
    user: UserDisplayViewModel|null
    propName?: keyof UserDisplayViewModel
}

export const UserDisplayName: React.FunctionComponent<UserDisplayNameProps> = ({
    user,
    propName = 'name',
}) => {
    if (user === null) return null
    
    return (
        <React.Fragment>
            <Typography>{user[propName]}</Typography>
            {!user.isActive && (
                <Typography color='secondary'>(inactive)</Typography>
            )}
        </React.Fragment>
    )
}